export default {
  namespaced: true,
  state() {
    return {
      isOn: false,
      menuItems: [
        { label: "Recent updates", isUserOnly: true, type: "badge", badgeCount: 12 },
        { label: "My account", isUserOnly: true, path: '/my-account/profile', enabled: true},
        { label: "Banking", isUserOnly: true},
        { label: "Messages", isUserOnly: true, type: "badge", badgeCount: 9 },
        // { label: "Promotions", isUserOnly: false },
        // { label: "App", isUserOnly: false },
        { label: "Support", isUserOnly: false},
        { label: "Corporate affairs", isUserOnly: false},
        { label: "Language", isUserOnly: false, type: "icon", icon: "uk", enabled: true },
        { label: "Logout", isUserOnly: true }
      ],
      subMenuItems: [
        { label: "Dashboard", parent: "My account", path: "/my-account/" },
        { label: "Profile", parent: "My account", path: "/my-account/profile" },
        { label: "Player protection tools", parent: "My account", path: "/my-account/player-protection-tools" },
        { label: "Bank accounts", parent: "My account", path: "/my-account/bank-accounts" },
        { label: "Statement", parent: "My account", path: "" },
        { label: "Settings", parent: "My account", path: "/my-account/settings" },
        { label: "Deposit", parent: "Banking", path: "" },
        { label: "Withdrawal", parent: "Banking", path: "" },
        { label: "Recent transactions", parent: "Banking", path: "" },
        { label: "Settings", parent: "Banking", path: "" },
        { label: "FAQ", parent: "Support", path: "" },
        { label: "Rules", parent: "Support", path: "" },
        { label: "Contact us", parent: "Support", path: "" },
        { label: "Live chat", parent: "Support", path: "" },
        { label: "About us", parent: "Corporate affairs", path: "" },
        { label: "Affiliates", parent: "Corporate affairs", path: "" },
        { label: "Responsible gaming", parent: "Corporate affairs", path: "" },
        { label: "Terms and conditions", parent: "Corporate affairs", path: "" },
        { label: "Privacy policy", parent: "Corporate affairs", path: "" },
        { label: "Sitemap", parent: "Corporate affairs", path: "" },
        { label: "English", parent: "Language", path: "", icon: "uk", value: "en"},
        { label: "简体", parent: "Language", path: "", icon: "cn", value: "zh"}
      ]
    }
  },

  getters: {
    isOn(state) {
      return state.isOn
    },

    menuItems(state) {
      return state.menuItems
    },
    subMenuItems(state) {
      return state.subMenuItems
    },
  },
  mutations: {
    toggleDrawer(state, status) {
      status === undefined ? (state.isOn = !state.isOn) : (state.isOn = status)
    },
  },
  actions: {
    toggleDrawer({ commit }, payload) {
      commit("toggleDrawer", payload)
    }
  }
}
